module.exports = __webpack_public_path__ + "static/media/export_example.279ffd3f.csv";